import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.ends-with.js";
import { getData } from "@/services/axios";

import { useVModel, useFileDialog } from '@vueuse/core';
import { ref } from 'vue';
export default {
  __name: 'ForumEditAttachment',
  props: {
    value: {
      /** @type {PropType<File | any>} */
      type: [File, Object],
      default: undefined
    }
  },
  emits: ["input", "toggleIsDelete"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;

    // @ts-check

    var attachment = useVModel(props, "value", emit, {
      eventName: "input"
    });
    var attachmentError = ref("");
    var _useFileDialog = useFileDialog({
        multiple: false
      }),
      open = _useFileDialog.open,
      reset = _useFileDialog.reset,
      onChange = _useFileDialog.onChange;
    onChange(function (files) {
      if (checkFile(files[0])) {
        attachment.value = files[0];
        attachmentError.value = "";
      } else {
        reset();
      }
    });
    var checkFile = function checkFile(file) {
      //拡張子はpdf, jpg, jpeg, png, gif
      var fileName = file.name;
      if (!(fileName.endsWith(".pdf") || fileName.endsWith(".jpg") || fileName.endsWith(".jpeg") || fileName.endsWith(".png") || fileName.endsWith(".gif"))) {
        attachmentError.value = "ファイルの種類が不正です。添付できるファイルの種類はpdf, jpg, jpeg, png, gifです。";
        return false;
      }
      //サイズは5MBまで
      if (file.size > 5242880) {
        attachmentError.value = "ファイルサイズが5MBを超えています。添付できるファイルのサイズは5MB以下です。";
        return false;
      }
      return true;
    };
    var unsetAttachment = function unsetAttachment() {
      reset();
      attachment.value = null;
      emit("toggleIsDelete", true);
    };
    var getS3SignedUrl = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(key) {
        var newWindow, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              //secure browserのpopup block 対策
              newWindow = window.open();
              _context.p = 1;
              _context.n = 2;
              return getData("government_forum/get_s3_signed_url?path=" + encodeURIComponent(key));
            case 2:
              data = _context.v;
              newWindow.location = data.items.s3url;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log(_t);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function getS3SignedUrl(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      attachment: attachment,
      attachmentError: attachmentError,
      open: open,
      reset: reset,
      onChange: onChange,
      checkFile: checkFile,
      unsetAttachment: unsetAttachment,
      getS3SignedUrl: getS3SignedUrl
    };
  }
};